import { cn } from "@/lib/utils";
import { HTMLMotionProps, motion } from "framer-motion";

export const Overlay = ({
    className,
    ...props
}: HTMLMotionProps<"div"> & { className?: string }) => {
    const MotionDiv = motion.div as any;

    return (
        <MotionDiv
            className={cn(
                "fixed inset-0 h-screen w-screen bg-[rgba(0,0,0,0.4)]",
                className
            )}
            {...props}
        />
    );
};
